import { render, staticRenderFns } from "./selectGuardian.vue?vue&type=template&id=64276575&"
import script from "./selectGuardian.vue?vue&type=script&lang=js&"
export * from "./selectGuardian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports